import React from 'react';

export const Automatic = () => {
    return (
        <div>
            automatic
        </div>
    );
};
